import { logUnifiedTelemetry } from 'owa-analytics';
import {
    type UTCalendarFeatureName,
    type UTCalendarUIContext,
    type UTCalendarEventFeatureAction,
    type IUTECalendarEventUserActionArgs,
    type UTPlaceResourceType,
    type UTCalendarOrigin,
    type IUTSpaceReservationDataArgs,
} from '@outlook/unified_telemetry';

export default function logSpaceReservation(
    spaceType: UTPlaceResourceType,
    entryPoint: {
        context: UTCalendarUIContext;
        origin?: UTCalendarOrigin;
    },

    // Indicates the action taken by the user
    featureAction: UTCalendarEventFeatureAction,

    // The UI context in which the action was taken
    uiContext: UTCalendarUIContext,
    origin?: UTCalendarOrigin,

    // Optional datas
    calendarEventData?: Pick<IUTECalendarEventUserActionArgs, 'IsNew' | 'ChangedPropertyNameList'>,
    spaceReservationData?: Omit<IUTSpaceReservationDataArgs, 'SpaceType'>,

    // If empty, it means the action was successful
    failureInfo?: string
): void {
    const data: IUTECalendarEventUserActionArgs = {
        FeatureName: 'SpaceReservation',
        FeatureAction: featureAction,
        FeatureUIContext: uiContext,
        Origin: origin,
        ActionSuccess: !failureInfo,
        ActionFailureInfo: failureInfo,
        SourceUIContext: entryPoint.context,
        SourceOrigin: entryPoint.origin,
        ...(calendarEventData || {}),
        SpaceReservationData: {
            SpaceType: spaceType,
            ...spaceReservationData,
        },
    };
    logUnifiedTelemetry({
        eventName: 'CalendarEventUserAction',
        bypassEventMatchingCheck: true,
        data,
    });
}
